<script setup lang="ts">
import type { TooltipContentProps, TooltipRootEmits, TooltipRootProps } from "reka-ui";
import type { TooltipBox } from "./SimpleTooltipContent.vue";
import { reactiveOmit } from "@vueuse/core";
import { TooltipPortal, TooltipRoot, TooltipTrigger, useForwardPropsEmits } from "reka-ui";
import SimpleTooltipContent from "./SimpleTooltipContent.vue";

export type SimpleTooltipRootProps = TooltipRootProps & { content?: string; side?: TooltipContentProps["side"]; variant?: TooltipBox["variant"]; disabled?: boolean; constrainWidth?: boolean };

const props = defineProps<SimpleTooltipRootProps>();
const emits = defineEmits<TooltipRootEmits>();

const propsOmit = reactiveOmit(props, ["content", "side", "variant"]);
const forwarded = useForwardPropsEmits(propsOmit, emits);
</script>

<template>
  <TooltipRoot v-bind="forwarded">
    <slot v-if="props.content === undefined" />
    <template v-else>
      <TooltipTrigger as-child>
        <slot />
      </TooltipTrigger>
      <TooltipPortal>
        <SimpleTooltipContent :side="props.side" :variant="variant" :class="{ 'max-w-xs': props.constrainWidth }">
          {{ props.content }}
        </SimpleTooltipContent>
      </TooltipPortal>
    </template>
  </TooltipRoot>
</template>
